import { styled } from '@mui/material';
import { Accordion } from 'shell/components/Accordion';

const CriterionAccordion = styled(Accordion)(({ theme }) => ({
    '&.MuiAccordion-root': {
        borderRadius: theme.spacing(2),
    },
    '& .MuiAccordionSummary-root:hover': {
        background: theme.palette.ensightful.neutral[100],
    },
    '&:not(.Mui-expanded) > .MuiAccordionSummary-root:hover': {
        borderRadius: 'inherit',
    },
    '&.Mui-expanded > .MuiAccordionSummary-root:hover': {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
    },
}));

export default CriterionAccordion;
